<template>
    <li class="accordion__item">
        <div
            class="accordion__trigger mb-12"
            :class="{'accordion__trigger_active': active}"
            @click="open">

            <!-- This slot will handle the title/header of the accordion and is the part you click on -->

                <slot name="accordion-trigger"></slot>

        </div>

        <transition
            name="accordion"
            @enter="start"
            @after-enter="end"
            @before-leave="start"
            @after-leave="end">

            <div class="accordion__content" style="max-height: unset; opacity: 1;"
                 v-show="active">
                <ul style="padding-left:0;padding-right:0" class="mb-12 last:mb-8">
                    <!-- This slot will handle all the content that is passed to the accordion -->
                    <slot name="accordion-content"></slot>
                </ul>
            </div>
        </transition>
    </li>
</template>


<script>
import { ref } from 'vue'
export default {
    props: {
        isActive: {
            required: false,
            default: false
        }
    },
    methods: {
        open() {
            this.active = !this.active;
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        }
    },
    setup(props){
        const active = ref(props.isActive);

        return {
            active
        }
    },

};
</script>

<style lang="scss" scoped>
.accordion__item {
    position: relative;
}

.accordion-enter-active,
.accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
    height: 0 !important;
    opacity: 0;
}
</style>
